import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import _ from 'underscore';

import questionActions from '../../actions/questions';
import ResponsesManager from '../questions/responsesManager'
import { FocusPointsInputAndConceptSelectorForm, } from '../../../Shared/index';

class NewFocusPointsContainer extends Component {
  constructor() {
    super();

    this.state = { questionType: 'questions', questionTypeLink: 'questions', actionFile: questionActions }
  }

  getFocusPoints = () => {
    const { questionType } = this.state
    const { match } = this.props
    const { params } = match
    const { questionID } = params
    return this.props[questionType].data[questionID].focusPoints;
  }

  submitFocusPointForm = data => {
    const { actionFile } = this.state
    const { dispatch, match, history } = this.props
    const { params } = match
    const { questionID } = params
    if (data.conceptResults && data.conceptResults.null !== undefined) {
      delete data.conceptResults.null;
    }
    data.order = _.keys(this.getFocusPoints()).length + 1;
    dispatch(actionFile.submitNewFocusPoint(questionID, data, () => {
      history.push(`/admin/questions/${questionID}/focus-points`);
    }));
  };

  render() {
    const { match, questions } = this.props
    const { params } = match
    const { questionID } = params
    if(questions && questionID) {
      return (
        <div>
          <FocusPointsInputAndConceptSelectorForm
            itemLabel="Focus Point"
            onSubmit={this.submitFocusPointForm}
            questionID={questionID}
            questions={questions}
            ResponsesManager={ResponsesManager}
            states={true}
          />
        </div>
      );
    } else {
      return (
        <h1>Loading...</h1>
      );
    }
  }
}

function select(props) {
  return {
    questions: props.questions,
  }
}

export default withRouter(connect(select)(NewFocusPointsContainer));
